const deleteCodeUseCase = (repository) => async (id) => {
    return await repository(id);
}

export default deleteCodeUseCase;